// extracted by mini-css-extract-plugin
module.exports = {"intro-text":"intro-text_ReportHeading_3_hOL intro-text_base_3Shot","column":"column_ReportHeading_1p-2j","width-12":"width-12_ReportHeading_7LQC-"};